import { IInstallation, IUser } from '../../models';
import { doFetch, generateHeaders } from '../../helpers/fetcher';
import { fetchMethods } from '../../static/constants';

export const postEvent = async (user: IUser, installation: IInstallation, eventName: string): Promise<void> =>
    installation.installationId
        ? await doFetch(
              `events/${installation.integrationType}/installations/${installation.installationId}`,
              generateHeaders(user),
              fetchMethods.POST,
              {
                  eventName,
              }
          )
        : await doFetch(`events/${installation.integrationType}/public`, generateHeaders(user), fetchMethods.POST, {
              eventName,
          });
